const release = ""

const originURL = "https://www.rechtec.de"
const apiClientBaseURL = "/api/"

const cryptchaSiteId = "6628f06a0938460001505119"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

module.exports = {
    release,
    apiClientBaseURL,
    originURL,
    cryptchaSiteId,
}
